export default __webpack_public_path__ + "static/media/backarrow.1bbc3bd3.svg";